<div class="w-30rem">
  <ui-card>
    <form #registerForm="ngForm" (ngSubmit)="onSubmit(registerForm)" class="w-full flex flex-column gap-3">
      <div class="flex flex-column align-items-center justify-content-center gap-3">
        <img src="assets/Novatellus.svg" alt="Novatellus" class="w-12rem max-w-full h-auto" />
        <span class="text-2xl font-bold">Registrazione</span>
        <span class="text-sm">Crea il tuo account nfarm</span>
      </div>

      <div class="w-full flex flex-column gap-2">
        <ng-container *ngFor="let field of fieldsConfig">
          <span class="w-full flex flex-column gap-2">
            <label [for]="field.key">{{ field.label }}{{ field.required ? '*' : '' }}</label>
            <ng-container [ngSwitch]="field.type">
              <p-password
                *ngSwitchCase="'password'"
                [id]="field.key"
                [name]="field.key"
                [(ngModel)]="registerFormModel[field.key]"
                [required]="field.required"
                [minlength]="field.validators?.minlength ?? null"
                [maxlength]="field.validators?.maxlength ?? null"
                [feedback]="false"
                class="w-full"
                styleClass="w-full"
                inputStyleClass="w-full"
                [toggleMask]="true"
              ></p-password>
              <input
                *ngSwitchDefault
                [id]="field.key"
                [type]="field.type"
                pInputText
                [name]="field.key"
                [(ngModel)]="registerFormModel[field.key]"
                [required]="field.required"
                [email]="field.validators?.email ?? false"
                [minlength]="field.validators?.minlength ?? null"
                [maxlength]="field.validators?.maxlength ?? null"
                class="w-full"
              />
            </ng-container>
          </span>
        </ng-container>
      </div>

      <small *ngIf="passwordsDoNotMatch" class="text-red-500">Le password non coincidono.</small>

      <div class="w-full flex flex-column gap-3">
        <p-button
          type="submit"
          label="Registrati"
          [disabled]="(registerForm.invalid ?? true) || passwordsDoNotMatch"
          styleClass="w-full"
        />
        <span class="text-center text-sm">
          Hai gia un account?
          <p-button
            label="Accedi"
            [text]="true"
            size="small"
            severity="secondary"
            styleClass="underline p-0"
            [routerLink]="['/', AppRoutes.AUTH, AppRoutes.AUTH_LOGIN]"
          />
        </span>
      </div>
    </form>
  </ui-card>
</div>
